<p-menubar #primMenuBar [model]="menuItems">
    <ng-template #start>
    </ng-template>
    <ng-template #item let-item let-root="root">
        <a pRipple class="flex items-center p-menubar-item-link">
            <span>{{ item.label }}</span>
            <p-badge *ngIf="item.badge" [ngClass]="{ 'ml-auto': !root, 'ml-2': root }" [value]="item.badge" />
            <span *ngIf="item.shortcut" class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">{{ item.shortcut }}</span>
            <i *ngIf="item.items" [ngClass]="['ml-auto pi', root ? 'pi-angle-down' : 'pi-angle-right']"></i>
        </a>
    </ng-template>
    <ng-template #end>
        <div class="dx-menubar-base">
        <ng-container  *ngFor="let ctrl of adjacentItems" >
                    <ng-container *ngIf="ctrl.controlType === 'avatar'" >
                        <dx-avatar></dx-avatar>
                    </ng-container>
                    <ng-container *ngIf="ctrl.controlType === 'search'" >
                        <input type="text" pInputText placeholder="Search">
                    </ng-container>
                    <ng-container *ngIf="ctrl.controlType === 'bell'" >
                        <button pButton pRipple type="button" class="p-button-rounded  p-button-secondary p-button-text" (click)="menu.toggle($event)">
                            <i *ngIf="ctrl.badgeNotifEnable" class="fa fa-bell badge-danger-size" aria-hidden="true" pBadge style="font-size: 1.3rem;" 
                            severity="danger"></i>
                            <i *ngIf="!ctrl.badgeNotifEnable" class="fa fa-bell" aria-hidden="true"  style="font-size: 1.3rem;" ></i>
                        </button>
                        <p-menu #menu [popup]="true" [model]="ctrl.listItems || []"></p-menu>
                    </ng-container>
                    <ng-container *ngIf="ctrl.controlType === 'button' && ctrl.config.visible" >
                        <dx-button [text]="ctrl.config.text" [icon]="ctrl.config.icon" (onClick)="ctrl.config.onClick($event)"></dx-button>
                    </ng-container>
            </ng-container>
            <!-- <button type="button" pButton label="Logout" icon="pi pi-power-off" style="margin-left:.25em"></button> -->
        </div>
    </ng-template>
</p-menubar>